import { render, staticRenderFns } from "./personalHeader.vue?vue&type=template&id=5e46cb9c&scoped=true&"
import script from "./personalHeader.vue?vue&type=script&lang=ts&"
export * from "./personalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./personalHeader.vue?vue&type=style&index=0&id=5e46cb9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e46cb9c",
  null
  
)

export default component.exports